import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import BotpressBotStatus from "../widgets/botpressBotStatus";
import BotpressBotUseage from "../widgets/botpressBotUseage";
import BotpressConversations from "../widgets/botpressConversations";

const BotpressConversationPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Conversation History" />
      <PortalGridContent>
        <Grid size={{ xs: 12 }}>
          <BotpressConversations />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressConversationPortal);
